
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ChillsGraded',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ChillsGraded.vue